var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3858",
    d: "M15.998 11.078L10.3882 8.04522L0.650371 2.78157C0.641482 2.77247 0.623705 2.77248 0.614816 2.77248C0.259259 2.59975 -0.105186 2.96338 0.0281476 3.32702L4.98994 16.2698L4.99083 16.2725C4.99616 16.2852 5.00061 16.298 5.00594 16.3107C5.2095 16.7934 5.65394 17.0916 6.1375 17.2089C6.17839 17.218 6.20764 17.2262 6.25673 17.2362C6.30559 17.2473 6.37394 17.2625 6.43261 17.2671C6.44239 17.268 6.45128 17.268 6.46106 17.2689H6.46817C6.47528 17.2698 6.48239 17.2698 6.4895 17.2707H6.49928C6.5055 17.2716 6.51261 17.2716 6.51883 17.2716H6.53039C6.5375 17.2725 6.54461 17.2725 6.55172 17.2725C12.8348 17.9731 19.1763 17.9731 25.4593 17.2725C25.5349 17.2725 25.6087 17.2689 25.6798 17.2616C25.7029 17.2589 25.7251 17.2562 25.7473 17.2534C25.75 17.2525 25.7536 17.2525 25.7562 17.2516C25.7713 17.2498 25.7864 17.2471 25.8016 17.2443C25.8238 17.2416 25.846 17.2371 25.8682 17.2325C25.9127 17.2225 25.9329 17.2152 25.9932 17.194C26.0535 17.1729 26.1536 17.1358 26.2163 17.1049C26.279 17.074 26.3224 17.0443 26.3749 17.0107C26.4398 16.9689 26.5015 16.9261 26.5641 16.8781C26.5911 16.8569 26.6096 16.8434 26.6291 16.8243L26.6184 16.818L15.998 11.078Z",
    fill: "#FF2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5063",
    d: "M31.3616 2.78158H31.3527L21.6113 8.04524L27.0265 16.2935L31.9758 3.32704V3.30886C32.1003 2.92704 31.7181 2.58158 31.3616 2.78158Z",
    fill: "#7D353B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5101",
    d: "M16.5171 0.278788C16.2682 -0.0930318 15.726 -0.0930318 15.486 0.278788L10.3882 8.04518L15.998 11.0779L26.6291 16.8242C26.6959 16.7574 26.7494 16.6922 26.806 16.6234C26.886 16.5225 26.9607 16.4143 27.0265 16.2934L21.6113 8.04518L16.5171 0.278788Z",
    fill: "#BD4043"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.b972e133efb66853e2af89f9219f1069.svg";